import { useState, useContext } from "react";
import { useLocation, matchPath, Link, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import ManageNavConfig from "./NaveBarConfit";
import AuthService from "services/AuthService";
import { ReactComponent as LogoutIcon } from "images/svg/logout.svg";
import LogoutConfirmDialog from "components/popups/LogoutConfirmDialog.js";
import Loader from "../Loading/index.js";
import toast from "react-hot-toast";
import { ROUTES } from "const";
import ShopContext from "context/ShopContext";

function ManageNavebar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { hasFullKotValidity, hasLabelScaleValidity } = useContext(ShopContext);

  const match = (path) => (path ? matchPath(`${path}/*`, pathname) : false);

  const handleLogoutConfirm = async () => {
    setShowLogoutDialog(false);
    setIsLoading(true);

    try {
      await AuthService.logout();
      navigate(ROUTES.LOGIN, { replace: true });
    } catch (error) {
      toast.error("Logout failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const filteredNavConfig = ManageNavConfig.filter((nav) => {
    if (nav.id === "servers") {
      return hasFullKotValidity || hasLabelScaleValidity;
    }
    return true;
  });

  return (
    <>
      <Loader isOpen={isLoading} />
      <Grid container className={styles.CategoryWrapper}>
        <Grid item xs={12}>
          <Grid container>
            {filteredNavConfig.map((nav) => (
              <Link
                key={nav.id}
                className={`${styles.navLinkWrapper} ${match(nav.path) ? styles.activeNavLink : ""}`}
                to={nav.submenu ? pathname : nav.path}
              >
                <div className={styles.navbarContainer}>
                  <div className={styles.link}>
                    <nav.icon className={`${styles.icon} ${match(nav.path) ? styles.activeNavLinkIcon : ""}`} />
                  </div>
                  <div className={styles.linkText}>
                    <h5 className={styles.navLinkText}>
                      {nav.id === "Sanoft-POS" ? (
                        <>
                          <span style={{ color: "#E50218" }}>Sanoft</span>
                          <span style={{ color: "#2b2b2b" }}>POS</span>
                        </>
                      ) : (
                        nav.name
                      )}
                    </h5>

                    <div className={styles.navLinkDescription}>{nav.description}</div>
                  </div>
                </div>
              </Link>
            ))}

            <div className={`${styles.navLinkWrapper} ${styles.logoutItem}`} onClick={() => setShowLogoutDialog(true)}>
              <div className={styles.navbarContainer}>
                <div className={styles.link}>
                  <LogoutIcon className={styles.icon} />
                </div>
                <div className={styles.linkText}>
                  <h5 className={styles.navLinkText}>Logout</h5>
                  <div className={styles.navLinkDescription}>Sign out of account</div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>

      <LogoutConfirmDialog
        open={showLogoutDialog}
        onClose={() => setShowLogoutDialog(false)}
        onConfirm={handleLogoutConfirm}
      />
    </>
  );
}

export default ManageNavebar;
